module.exports = __webpack_public_path__ + "static/media/SFMono-Semibold.cebe2bfb.woff2";